/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Enumerates the options for how data loaded animations are displayed.
 */
export var CellDataLoadedAnimationMode = /*@__PURE__*/ (function (CellDataLoadedAnimationMode) {
    /**
     * The correct animation mode is automatically selected.
     */
    CellDataLoadedAnimationMode[CellDataLoadedAnimationMode["Auto"] = 0] = "Auto";
    /**
     * No animation is performed.
     */
    CellDataLoadedAnimationMode[CellDataLoadedAnimationMode["None"] = 1] = "None";
    /**
     * The previous value and the next value are crossfaded between.
     */
    CellDataLoadedAnimationMode[CellDataLoadedAnimationMode["CrossFade"] = 2] = "CrossFade";
    return CellDataLoadedAnimationMode;
})({});
/**
 * @hidden
 */
export var CellDataLoadedAnimationMode_$type = /*@__PURE__*/ markEnum('CellDataLoadedAnimationMode', 'Auto,0|None,1|CrossFade,2');
//# sourceMappingURL=CellDataLoadedAnimationMode.js.map
